import { findDocumentElement } from './DomUtils';

const ClickAction = {
  start(step) {
    const elt = findDocumentElement(step.element);
    if (elt) {
      elt.click();
    }
  },
  stop(step) {
    const elt = findDocumentElement(step.element);
    if (elt) {
      elt.click();
    }
  },
};

export default ClickAction;
